import constants from '../../../../globalization';

export default [
  {
    name: constants.curbSideOrder,
    id: 1,
    checked: false,
  },
  {
    name: constants.onlineOrder,
    id: 2,
    checked: false,
  },
  {
    name: constants.callIn,
    id: 3,
    checked: false,
  },
  {
    name: constants.walkup,
    id: 4,
    checked: false,
  },
  {
    name: constants.prepTime,
    id: 5,
    checked: false,
  },
  {
    name: constants.production,
    id: 6,
    checked: false,
  },
  {
    name: constants.preAuthLabel,
    id: 7,
    checked: false,
  },
];
